/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTime: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
};

export type Authentication = {
  __typename?: 'Authentication';
  /** The token to include in future requests to this API. */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** Indicates whether an additional MFA step is required */
  additionalAuthRequired?: Maybe<Scalars['Boolean']['output']>;
  /** The ISO Date string in the format "2022-12-06T13:33:08.000Z". */
  expiresAt: Scalars['DateTime']['output'];
  /** If this is not null, the client must redirect to this URL. */
  redirectToURL?: Maybe<Scalars['String']['output']>;
  /** Returned only from the `socialLogin` mutation. Will be true if a LottieFiles account was created in the `socialLogin`. */
  socialLoginAccountCreated?: Maybe<Scalars['Boolean']['output']>;
  /** The token type, e.g. "Bearer". */
  tokenType: Scalars['String']['output'];
};

export type DirectoryUser = {
  __typename?: 'DirectoryUser';
  /** The id of the directory user */
  directoryUserId: Scalars['String']['output'];
  /** The email of the directory user */
  email: Scalars['String']['output'];
  /** The Kratos user id of the directory user */
  kratosUserId: Scalars['String']['output'];
  /** The organization id that the directory user belongs to */
  organizationId: Scalars['String']['output'];
};

export type Locale = {
  __typename?: 'Locale';
  code: Scalars['String']['output'];
  fallbackCode: Scalars['String']['output'];
};

export type LocaleListing = {
  __typename?: 'LocaleListing';
  locales?: Maybe<Array<Locale>>;
};

export type LoginToken = {
  __typename?: 'LoginToken';
  /** The URL to direct the user to in order to conclude the token login. */
  loginUrl: Scalars['String']['output'];
  /** The token to use with the tokenLogin mutation. */
  token: Scalars['String']['output'];
};

export type LookupSecret = {
  __typename?: 'LookupSecret';
  /** The recovery code strings */
  codes?: Maybe<Array<Scalars['String']['output']>>;
  /** The result status of the requested action */
  status: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Cancels the ongoing email change process for the user. */
  cancelEmailChange: User;
  /** Completes an email change process. */
  confirmEmailChange: Scalars['Boolean']['output'];
  /** Completes a reset password process. Will also logout the user from all existing sessions. */
  confirmResetPassword: Scalars['Boolean']['output'];
  /** Initiates the long poll token login process. */
  createLoginToken: LoginToken;
  /** Completes the email verification process. */
  emailVerificationConfirm: Scalars['Boolean']['output'];
  /** Links the account for enterprise login (workos provider) and logs user in. */
  enterpriseLinkWithLogin: Authentication;
  /** Completes the Enterprise login process. */
  enterpriseLogin: Authentication;
  /** @deprecated Use the query `isUsernameAvailable` instead of this mutation. */
  isUsernameAvailable: Scalars['Boolean']['output'];
  /** Logouts the current user, "true" if the session is successfully destroyed. */
  logout: Scalars['Boolean']['output'];
  /** Disables lookup secrets for a user */
  lookupSecretsDisable: Scalars['Boolean']['output'];
  /** Login using generated lookup secrets (recovery codes) */
  lookupSecretsLogin: Authentication;
  /** Generates new lookup secrets for a user */
  lookupSecretsRegenerate: LookupSecret;
  /** To be called by an authenticated user. It marks the token for the login token process as valid, and enables the `tokenLogin` mutation to receive a new session based on the token. */
  markLoginTokenValid: Scalars['Boolean']['output'];
  /** Accepts an OAuth consent request for the given consent challenge and selected scopes, and returns the redirect URL. */
  oAuthConsentRequestAccept: Scalars['String']['output'];
  /** Rejects an OAuth consent request for the given consent challenge and selected scopes, and returns the redirect URL. */
  oAuthConsentRequestReject: Scalars['String']['output'];
  /** Submit the answer to an onboarding question. */
  onboardingAnswerSubmit?: Maybe<OnboardingAnswer>;
  /** Accepts organization invitation. Links directory user to Kratos user. */
  organizationInviteAccept: DirectoryUser;
  /** Updates a user's password. */
  passwordChange: Scalars['Boolean']['output'];
  /** Email/Password user login. */
  passwordLogin: Authentication;
  /** Finishes the process of uploading a new profile image. Must be called right after finishing PUTing the file to the signed URL provided by the `uploadProfilePhoto` mutation. Will process the uploaded image into different sizes and store them. */
  processUserProfilePhotoUpload: Scalars['Boolean']['output'];
  /** Email/Password user registration. */
  register: Authentication;
  /** Initiates the email change process, will fire an email for the user to conclude the email change process. */
  requestEmailChange: User;
  /** Resends the change email confirmation email message. */
  resendEmailChangeEmail: Scalars['Boolean']['output'];
  /** Resends the verification email for the current logged in user. */
  resendVerificationEmail: Scalars['Boolean']['output'];
  /** Will send a reset password email, if the email belongs to a registered user. */
  resetPassword: Scalars['Boolean']['output'];
  /** Key/value of data associated with the session. Sets a value for a key to the current logged in session. If value is not sent, unsets the given key. */
  sessionSetValue: Scalars['Boolean']['output'];
  /** Initiate a request to clear the sessions for the current user. */
  sessionsClear: Scalars['Boolean']['output'];
  /** Completes a clear sessions process. */
  sessionsConfirmClear: Scalars['Boolean']['output'];
  /** Sets the segments to apply to the current logged in user. */
  setUserSegments: Scalars['Boolean']['output'];
  /** Login with a social provider. Accepted providers: "dribbble", "google", "facebook", "twitter", "apple", "github". */
  socialLogin: Authentication;
  /** Links the account with a social provider. Accepted providers: "dribbble", "google", "facebook", "twitter", "apple", "github", "workos". */
  socialLoginLink: Scalars['Boolean']['output'];
  /** Unlinks the account and a social provider. Accepted providers: "dribbble", "google", "facebook", "twitter", "apple", "github", "workos". */
  socialLoginUnlink: Scalars['Boolean']['output'];
  /** Checks if the user completed the token login authentication. Will return the accessToken if completed, otherwise it will return an error. */
  tokenLogin: Authentication;
  /** Completes the TOTP link to a user account */
  totpLinkConfirm: LookupSecret;
  /** TOTP MFA login. */
  totpLogin: Authentication;
  /** Unlinks TOTP from the current user. */
  totpUnlink: Scalars['Boolean']['output'];
  /** Confirms and unsubscribes the user with the code. */
  unsubscribeEmailConfirm: Scalars['Boolean']['output'];
  /** Sends the unsubscribe confirm email message. */
  unsubscribeEmailRequest: Scalars['Boolean']['output'];
  /** Updates the current user's profile data. */
  updateUser: User;
  /** Starts the upload profile picture process. Returns a signed URL that should be used in a PUT request with the file content. The `processUserProfilePhotoUpload` mutation must be called right after the file upload has finished. */
  uploadProfilePhoto: UserProfilePhotoUpload;
  /** Verify the user email address with a code */
  userEmailVerify: User;
  /** Update the user preferred locale */
  userLocaleUpdate: Scalars['Boolean']['output'];
  /** Request the start of self-service account deletion. */
  userSelfDeleteRequest: Scalars['Boolean']['output'];
  /** Updates user's notification preference */
  viewerNotificationPreferenceUpdate: ViewerNotificationPreference;
  /** Deletes user's Slack notification webhook integration */
  viewerSlackNotificationWebhookDelete: Scalars['Boolean']['output'];
  /** Sets user's Slack notification webhook integration */
  viewerSlackNotificationWebhookSet: Scalars['Boolean']['output'];
};

export type MutationConfirmEmailChangeArgs = {
  emailChangeToken: Scalars['String']['input'];
};

export type MutationConfirmResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};

export type MutationCreateLoginTokenArgs = {
  appKey?: InputMaybe<Scalars['String']['input']>;
};

export type MutationEmailVerificationConfirmArgs = {
  emailVerificationToken: Scalars['String']['input'];
};

export type MutationEnterpriseLinkWithLoginArgs = {
  code: Scalars['String']['input'];
  web: Scalars['Boolean']['input'];
};

export type MutationEnterpriseLoginArgs = {
  code: Scalars['String']['input'];
  loginChallenge?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationIsUsernameAvailableArgs = {
  username: Scalars['String']['input'];
};

export type MutationLogoutArgs = {
  web?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationLookupSecretsLoginArgs = {
  code: Scalars['String']['input'];
  loginChallenge?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationMarkLoginTokenValidArgs = {
  token: Scalars['String']['input'];
};

export type MutationOAuthConsentRequestAcceptArgs = {
  consentChallenge: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
};

export type MutationOAuthConsentRequestRejectArgs = {
  consentChallenge: Scalars['String']['input'];
};

export type MutationOnboardingAnswerSubmitArgs = {
  input: OnboardingAnswerSubmitInput;
};

export type MutationOrganizationInviteAcceptArgs = {
  invitationCode: Scalars['String']['input'];
};

export type MutationPasswordChangeArgs = {
  newPassword: Scalars['String']['input'];
};

export type MutationPasswordLoginArgs = {
  email: Scalars['String']['input'];
  loginChallenge?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  web?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationProcessUserProfilePhotoUploadArgs = {
  filename: Scalars['String']['input'];
  signedUrl: Scalars['String']['input'];
};

export type MutationRegisterArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  loginChallenge?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  verificationToken?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationRequestEmailChangeArgs = {
  email: Scalars['String']['input'];
};

export type MutationResendVerificationEmailArgs = {
  returnTo?: InputMaybe<Scalars['String']['input']>;
};

export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};

export type MutationSessionSetValueArgs = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSessionsClearArgs = {
  email: Scalars['String']['input'];
};

export type MutationSessionsConfirmClearArgs = {
  sessionsClearToken: Scalars['String']['input'];
};

export type MutationSetUserSegmentsArgs = {
  segmentIds: Scalars['String']['input'];
  segmentOtherDescription?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSocialLoginArgs = {
  accessSecret?: InputMaybe<Scalars['String']['input']>;
  accessToken?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  loginChallenge?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  web?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationSocialLoginLinkArgs = {
  accessSecret?: InputMaybe<Scalars['String']['input']>;
  accessToken?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
};

export type MutationSocialLoginUnlinkArgs = {
  provider: Scalars['String']['input'];
};

export type MutationTokenLoginArgs = {
  token: Scalars['String']['input'];
};

export type MutationTotpLinkConfirmArgs = {
  code: Scalars['String']['input'];
  flowId: Scalars['String']['input'];
};

export type MutationTotpLoginArgs = {
  code: Scalars['String']['input'];
  loginChallenge?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUnsubscribeEmailConfirmArgs = {
  code: Scalars['String']['input'];
};

export type MutationUnsubscribeEmailRequestArgs = {
  email: Scalars['String']['input'];
};

export type MutationUpdateUserArgs = {
  behanceUsername?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dribbbleUsername?: InputMaybe<Scalars['String']['input']>;
  enableMarketingEmails?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  githubUsername?: InputMaybe<Scalars['String']['input']>;
  instagramUsername?: InputMaybe<Scalars['String']['input']>;
  isHireable?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedinUsername?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  twitterUsername?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUploadProfilePhotoArgs = {
  extension: Scalars['String']['input'];
};

export type MutationUserEmailVerifyArgs = {
  code: Scalars['String']['input'];
};

export type MutationUserLocaleUpdateArgs = {
  locale: Scalars['String']['input'];
};

export type MutationUserSelfDeleteRequestArgs = {
  offboardingQuestions: Array<OffboardingQuestionInput>;
  reason: Scalars['String']['input'];
};

export type MutationViewerNotificationPreferenceUpdateArgs = {
  input: NotificationPreferenceUpdateInput;
};

export type MutationViewerSlackNotificationWebhookSetArgs = {
  code: Scalars['String']['input'];
};

export type NotificationChannel = {
  __typename?: 'NotificationChannel';
  /** Is chat channel enabled */
  chat?: Maybe<Scalars['Boolean']['output']>;
  /** Is email channel enabled */
  email?: Maybe<Scalars['Boolean']['output']>;
  /** Is inApp channel enabled */
  inApp?: Maybe<Scalars['Boolean']['output']>;
  /** Is push channel enabled */
  push?: Maybe<Scalars['Boolean']['output']>;
  /** Is sms channel enabled */
  sms?: Maybe<Scalars['Boolean']['output']>;
};

export enum NotificationChannelType {
  Chat = 'Chat',
  Email = 'Email',
  InApp = 'InApp',
  Push = 'Push',
  Sms = 'Sms',
}

export type NotificationGroup = {
  __typename?: 'NotificationGroup';
  /** The id of the notification group */
  id: Scalars['String']['output'];
  /** The name of the notification group */
  name: Scalars['String']['output'];
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  /** The specific channels that are enabled or not */
  channels: NotificationChannel;
  /** All channels will be turned off if false, regardless of individual channels options */
  enabled: Scalars['Boolean']['output'];
};

export type NotificationPreferenceUpdateInput = {
  /** The channel to be enabled */
  channel: NotificationChannelType;
  /** To enable notification preference */
  enabled: Scalars['Boolean']['input'];
  /** The ID of the notification template */
  templateId: Scalars['String']['input'];
};

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  /**
   * User will not be able to disable notification if true
   * @deprecated This field is not available in Novu Cloud.
   */
  critical: Scalars['Boolean']['output'];
  /** The description of the notification template */
  description?: Maybe<Scalars['String']['output']>;
  /** The id of the notification template */
  id: Scalars['String']['output'];
  /** The name of the notification template */
  name: Scalars['String']['output'];
  /**
   * The notification template group info
   * @deprecated This field is not available in Novu Cloud and will be replaced by tags.
   */
  notificationGroup: NotificationGroup;
};

export type OAuthConsentRequest = {
  __typename?: 'OAuthConsentRequest';
  /** The name of the OAuth client that's requesting for consent. */
  clientName: Scalars['String']['output'];
  /** If skip is true, the client must redirect to this URL. */
  redirectToURL?: Maybe<Scalars['String']['output']>;
  /** The scopes requested for user consent. Will not be returned if skip is `true`. */
  scopes?: Maybe<Array<OAuthConsentRequestScope>>;
  /** If true, you must redirect to the URL in the `redirectToURL` field. */
  skip: Scalars['Boolean']['output'];
};

export type OAuthConsentRequestScope = {
  __typename?: 'OAuthConsentRequestScope';
  /** The description of the scope. */
  description: Scalars['String']['output'];
  /** The ID of the scope. */
  id: Scalars['ID']['output'];
  /** The OAuth scope. */
  scope: Scalars['String']['output'];
};

export type OAuthLoginRequest = {
  __typename?: 'OAuthLoginRequest';
  /** If skip is true, the client must redirect to this URL. */
  redirectToURL?: Maybe<Scalars['String']['output']>;
  /** If true, you must redirect to the URL in the `redirectToURL` field. */
  skip: Scalars['Boolean']['output'];
};

export type OffboardingQuestionInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type OnboardingAnswer = {
  __typename?: 'OnboardingAnswer';
  /** The user answer to the slug in JSON format. */
  answer?: Maybe<Scalars['JSON']['output']>;
  answeredAt: Scalars['DateTime']['output'];
  slug: Scalars['String']['output'];
};

export type OnboardingAnswerSubmitInput = {
  answer?: InputMaybe<Scalars['JSON']['input']>;
  slug: Scalars['String']['input'];
};

export type OnboardingQuestion = {
  __typename?: 'OnboardingQuestion';
  answerJsonSchema: Scalars['JSON']['output'];
  slug: Scalars['String']['output'];
};

export type OrganizationPreferences = {
  __typename?: 'OrganizationPreferences';
  /** True if SAML linked users cannot change their email address. */
  isEmailChangeBlocked: Scalars['Boolean']['output'];
  /** True if users cannot access this organization's assets without SAML login. */
  isSsoEnforced: Scalars['Boolean']['output'];
  /** True if users cannot unlink SAML logins with this organization. */
  isUnlinkBlocked: Scalars['Boolean']['output'];
};

export type OrganizationSsoLogin = {
  __typename?: 'OrganizationSsoLogin';
  /** The organization name */
  name: Scalars['String']['output'];
  /** The sso login url */
  url: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  authVersion: Scalars['String']['output'];
  /** Initiates the Enterprise Login process. */
  enterpriseLoginAuthorizationUrl: Scalars['String']['output'];
  /** Initiates the Enterprise Login process using an org internal id. */
  enterpriseOrganizationLogin: OrganizationSsoLogin;
  /** Checks if a username is available for use. */
  isUsernameAvailable: Scalars['Boolean']['output'];
  jwt?: Maybe<Scalars['String']['output']>;
  /** Returns a list of locales available for selection. */
  locales?: Maybe<LocaleListing>;
  /** Generates new lookup secrets for a user */
  lookupSecretsReveal: LookupSecret;
  /** Fetches the consent request for the given consent challenge and returns whether the consent step can be skiped, and the list of requested scopes or redirect URL. */
  oAuthConsentRequest: OAuthConsentRequest;
  /** Fetches the login request for the given login challenge and returns whether the login step can be skiped. */
  oAuthLoginRequest: OAuthLoginRequest;
  /** Returns a list of onboarding questions for Workflow. */
  onboardingQuestions?: Maybe<Array<OnboardingQuestion>>;
  /** Start process to link a TOTP authenticator to the user */
  totpLinkStart: TotpLink;
  /** Get a user's public information based on ID. */
  user?: Maybe<User>;
  /** Returns a list of user segments available for choosing. */
  userSegments?: Maybe<UserSegmentListing>;
  /** Check if self-service account deletion is available for this user. */
  userSelfDeleteAvailable: Scalars['Boolean']['output'];
  /** Batch get users' public information based on ID. */
  users: Array<Maybe<User>>;
  /** Information about who owns the current session. */
  viewer: User;
  /** List of types of credentials enabled for this account. */
  viewerCredentials: Array<ViewerCredential>;
  /** Gets user's notification preferences */
  viewerNotificationPreferences: Array<ViewerNotificationPreference>;
};

export type QueryEnterpriseLoginAuthorizationUrlArgs = {
  email: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEnterpriseOrganizationLoginArgs = {
  orgInternalId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type QueryIsUsernameAvailableArgs = {
  username: Scalars['String']['input'];
};

export type QueryOAuthConsentRequestArgs = {
  consentChallenge: Scalars['String']['input'];
};

export type QueryOAuthLoginRequestArgs = {
  loginChallenge: Scalars['String']['input'];
};

export type QueryUserArgs = {
  id: Scalars['String']['input'];
};

export type QueryUsersArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};

export type TotpLink = {
  __typename?: 'TotpLink';
  flowId: Scalars['String']['output'];
  totpCode?: Maybe<Scalars['String']['output']>;
  totpImage?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  /** The date/time when the user authenticated the current session. */
  authenticatedAt: Scalars['DateTime']['output'];
  /** The user's profile picture. */
  avatarUrl: Scalars['String']['output'];
  /** The user's Behance username. */
  behanceUsername?: Maybe<Scalars['String']['output']>;
  /** The user's short Bio. */
  bio?: Maybe<Scalars['String']['output']>;
  /** The user's City of residence. */
  city?: Maybe<Scalars['String']['output']>;
  /** The user's Country of residence. */
  country?: Maybe<Scalars['String']['output']>;
  /** The date/time of account creation. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user's Dribbble username. */
  dribbbleUsername?: Maybe<Scalars['String']['output']>;
  /** The user's email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** True if the user's current email address has been verified. */
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  /** True if the user has agreed to receive marketing emails. */
  enableMarketingEmails?: Maybe<Scalars['Boolean']['output']>;
  /** The internal id of the enterprise org if the user has an e-sso session. */
  enterpriseOrgId?: Maybe<Scalars['String']['output']>;
  /** The user's first name. */
  firstName: Scalars['String']['output'];
  /** The user's Github username. */
  githubUsername?: Maybe<Scalars['String']['output']>;
  hasSlackNotificationEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The user's LottieFiles account's unique ID. */
  id: Scalars['String']['output'];
  /** The user's Instagram username. */
  instagramUsername?: Maybe<Scalars['String']['output']>;
  /** True if the user is available for work. */
  isHireable: Scalars['Boolean']['output'];
  /** @deprecated Legacy field, will always return false. */
  isPro: Scalars['Boolean']['output'];
  /** True if it's a service account. */
  isServiceAccount: Scalars['Boolean']['output'];
  /** The city where the user last logged in from. */
  lastLoggedInFromCity?: Maybe<Scalars['String']['output']>;
  /** The country where the user last logged in from. */
  lastLoggedInFromCountry?: Maybe<Scalars['String']['output']>;
  /** The timezone where the user last logged in from. */
  lastLoggedInTimezone?: Maybe<Scalars['String']['output']>;
  /** The user's last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** For use in the internal migration process. It will contain the ID of the user in the legacy WEB DB if the user is migrated. Otherwise, it will return an INT hashed from the user's Kratos ID. */
  legacyWebUserId: Scalars['Int']['output'];
  /** The user's Linkedin username. */
  linkedinUsername?: Maybe<Scalars['String']['output']>;
  /** The user's locale code. */
  locale?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `city` instead. */
  location?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `firstName` instead. */
  name: Scalars['String']['output'];
  onboardingAnswers?: Maybe<Array<OnboardingAnswer>>;
  /** The user's Twitter username. */
  twitterUsername?: Maybe<Scalars['String']['output']>;
  /** If the user is ongoing an email change process, this is the new email that the user is changing to. Otherwise it will be `null`. */
  unconfirmedNewEmail?: Maybe<Scalars['String']['output']>;
  /** The date/time of last account update. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use `username` instead. */
  url: Scalars['String']['output'];
  /** The segments this user belongs to. */
  userSegments?: Maybe<Array<UserSegment>>;
  /** The user's unique username. */
  username: Scalars['String']['output'];
  /** The user's personal website. */
  website?: Maybe<Scalars['String']['output']>;
};

export type UserProfilePhotoUpload = {
  __typename?: 'UserProfilePhotoUpload';
  filename: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type UserSegment = {
  __typename?: 'UserSegment';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type UserSegmentListing = {
  __typename?: 'UserSegmentListing';
  segments?: Maybe<Array<UserSegment>>;
};

export type ViewerCredential = {
  __typename?: 'ViewerCredential';
  /** Additional information on the credential. If enterprise sso then it will be the name of the organization */
  description?: Maybe<Scalars['String']['output']>;
  /** Internal ID of the organization for the credential, if available. */
  orgInternalId?: Maybe<Scalars['String']['output']>;
  /** The preferences of the organization for the credential, if available. */
  organizationPreferences?: Maybe<OrganizationPreferences>;
  /** The type of the credential. */
  type: Scalars['String']['output'];
};

export type ViewerNotificationPreference = {
  __typename?: 'ViewerNotificationPreference';
  /** The notification preference configs */
  preference: NotificationPreference;
  /** The notification preference template info */
  template: NotificationTemplate;
};

export type LookupSecretsLoginMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type LookupSecretsLoginMutation = {
  __typename?: 'Mutation';
  lookupSecretsLogin: {
    __typename?: 'Authentication';
    accessToken?: string | null;
    additionalAuthRequired?: boolean | null;
    expiresAt: any;
    redirectToURL?: string | null;
    socialLoginAccountCreated?: boolean | null;
    tokenType: string;
  };
};

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type ResetPasswordMutation = { __typename?: 'Mutation'; resetPassword: boolean };

export type EnterpriseLoginAuthorizationUrlQueryQueryVariables = Exact<{
  email: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
}>;

export type EnterpriseLoginAuthorizationUrlQueryQuery = {
  __typename?: 'Query';
  enterpriseLoginAuthorizationUrl: string;
};

export type PasswordLoginMutationVariables = Exact<{
  password: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;

export type PasswordLoginMutation = {
  __typename?: 'Mutation';
  passwordLogin: {
    __typename?: 'Authentication';
    tokenType: string;
    accessToken?: string | null;
    additionalAuthRequired?: boolean | null;
    expiresAt: any;
  };
};

export type LogoutMutationVariables = Exact<{
  web?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type LogoutMutation = { __typename?: 'Mutation'; logout: boolean };

export type TotpLoginMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type TotpLoginMutation = {
  __typename?: 'Mutation';
  totpLogin: {
    __typename?: 'Authentication';
    tokenType: string;
    additionalAuthRequired?: boolean | null;
    accessToken?: string | null;
    expiresAt: any;
  };
};

export type RegisterMutationVariables = Exact<{
  password: Scalars['String']['input'];
  email: Scalars['String']['input'];
  verificationToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type RegisterMutation = {
  __typename?: 'Mutation';
  register: { __typename?: 'Authentication'; tokenType: string; accessToken?: string | null; expiresAt: any };
};

export type ResendVerificationEmailMutationVariables = Exact<{
  returnTo?: InputMaybe<Scalars['String']['input']>;
}>;

export type ResendVerificationEmailMutation = { __typename?: 'Mutation'; resendVerificationEmail: boolean };

export type ViewerQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerQuery = {
  __typename?: 'Query';
  viewer: { __typename?: 'User'; email?: string | null; emailVerified?: boolean | null };
};

export type ViewerWithProfileQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerWithProfileQuery = {
  __typename?: 'Query';
  viewer: {
    __typename?: 'User';
    id: string;
    email?: string | null;
    emailVerified?: boolean | null;
    firstName: string;
    lastName?: string | null;
    country?: string | null;
    city?: string | null;
    behanceUsername?: string | null;
    dribbbleUsername?: string | null;
    isHireable: boolean;
    twitterUsername?: string | null;
    linkedinUsername?: string | null;
    instagramUsername?: string | null;
    website?: string | null;
    githubUsername?: string | null;
    username: string;
    avatarUrl: string;
    userSegments?: Array<{ __typename?: 'UserSegment'; id: number; title: string }> | null;
  };
};

export const LookupSecretsLoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'lookupSecretsLogin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lookupSecretsLogin' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'web' }, value: { kind: 'BooleanValue', value: true } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalAuthRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectToURL' } },
                { kind: 'Field', name: { kind: 'Name', value: 'socialLoginAccountCreated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tokenType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LookupSecretsLoginMutation, LookupSecretsLoginMutationVariables>;
export const ResetPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resetPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const EnterpriseLoginAuthorizationUrlQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'enterpriseLoginAuthorizationUrlQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enterpriseLoginAuthorizationUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'state' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EnterpriseLoginAuthorizationUrlQueryQuery,
  EnterpriseLoginAuthorizationUrlQueryQueryVariables
>;
export const PasswordLoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'passwordLogin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passwordLogin' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'web' }, value: { kind: 'BooleanValue', value: true } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tokenType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalAuthRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PasswordLoginMutation, PasswordLoginMutationVariables>;
export const LogoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'logout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'web' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'web' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'web' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const TotpLoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'totpLogin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totpLogin' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'web' }, value: { kind: 'BooleanValue', value: true } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tokenType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalAuthRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TotpLoginMutation, TotpLoginMutationVariables>;
export const RegisterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'register' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'verificationToken' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'register' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'web' }, value: { kind: 'BooleanValue', value: true } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'verificationToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'verificationToken' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tokenType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const ResendVerificationEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resendVerificationEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'returnTo' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resendVerificationEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'returnTo' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'returnTo' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const ViewerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'viewer' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewerQuery, ViewerQueryVariables>;
export const ViewerWithProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'viewerWithProfile' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'behanceUsername' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dribbbleUsername' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isHireable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'twitterUsername' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUsername' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                { kind: 'Field', name: { kind: 'Name', value: 'githubUsername' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userSegments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewerWithProfileQuery, ViewerWithProfileQueryVariables>;
